import { IonContent, IonPage } from "@ionic/react";
import Header from "../components/Header";
import AnimationContainer from "../components/Animation";

const Leaderboard: React.FC = () => {
  return (
    <IonPage>
      <Header title="Rankings" />
      <IonContent fullscreen>
        <div>
          <AnimationContainer animationName="botBuiltAnimation" />
          <div className="text-2xl font-semibold text-primary-50 text-center">
            Rankings Coming Soon
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Leaderboard;
